import React from 'react';
import { Camera, Upload } from 'lucide-react';

const SIZE_CLASSES = {
  xs: 'w-6 h-6 text-[9px]',
  sm: 'w-7 h-7 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-16 h-16 text-xl',
  xl: 'w-24 h-24 text-3xl',
};

export function AvatarDisplay({ userId, name, size = 'md', blobUrl, loadFailed, editable, uploading, dragging, fileRef, onDragOver, onDragLeave, onDrop, onFileChange }) {
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.md;
  const initial = name?.[0]?.toUpperCase() || 'U';

  return (
    <div
      className={`relative group ${editable ? 'cursor-pointer' : ''} ${dragging && editable ? 'ring-2 ring-[#0047AB] ring-offset-2' : ''}`}
      data-testid={`avatar-${userId || 'self'}`}
      onDragOver={editable ? onDragOver : undefined}
      onDragLeave={editable ? onDragLeave : undefined}
      onDrop={editable ? onDrop : undefined}
    >
      {blobUrl && !loadFailed ? (
        <img src={blobUrl} alt={name} className={`${sizeClass} rounded-sm object-cover`} onError={() => {}} />
      ) : (
        <div className={`${sizeClass} bg-slate-900 rounded-sm flex items-center justify-center`}>
          <span className="text-white font-bold">{initial}</span>
        </div>
      )}
      {editable && (
        <>
          <div onClick={() => fileRef.current?.click()}
            className={`absolute inset-0 rounded-sm flex items-center justify-center transition-opacity duration-200 ${dragging ? 'bg-[#0047AB]/60 opacity-100' : 'bg-black/40 opacity-0 group-hover:opacity-100'}`}>
            {uploading ? (
              <div className="animate-spin w-4 h-4 border-2 border-white border-t-transparent rounded-full" />
            ) : dragging ? (
              <Upload className="w-5 h-5 text-white" />
            ) : (
              <div className="flex flex-col items-center gap-0.5">
                <Camera className="w-4 h-4 text-white" />
                <span className="text-[8px] text-white font-medium">EDIT</span>
              </div>
            )}
          </div>
          <input ref={fileRef} type="file" accept="image/jpeg,image/png,image/webp,image/gif" onChange={onFileChange} className="hidden" data-testid="avatar-upload-input" />
        </>
      )}
    </div>
  );
}
